import { KeyNotFoundError } from "./getOwnProperty.ts";

export function getAndAssert<T, TKey>(map: Map<TKey, T>, key: TKey, objectName: string): T {
    const value = map.get(key);
    if (!value) {
        throw new KeyNotFoundError(key, objectName);
    }
    return value;
}
